import Form from './components/Form/Form';
import Table from './components/Table/Table';

function App() {
  return (
    <>
      <Form />
      <Table />
    </>
  );
}

export default App;
